import brand from './brand';
import type { ThemePalette } from './types';

const spacingPx = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  x5: 24,
  x6: 32,
  x7: 40,
  x8: 48,
  x10: 64,
  x12: 84,
  x14: 128,
  margin: 84,
  gutter: 24,
  marginMobile: 20,
  gutterMobile: 16,
  marginWide: 200,
  marginTablet: 58,
  gutterTablet: 20,
};

const spacing = Object.fromEntries(Object.entries(spacingPx).map(([key, px]) => [key, `${px}px`]));

// for now the brand fonts _are_ the semantic platform fonts, so mapping is
// just an assignment
const fonts = brand.fonts;

// default palette
const colors: ThemePalette = {
  bg: brand.colors.white,
  fg: brand.colors.black,
  secondaryBg: brand.colors.cream,
  cta: brand.colors.red,
  ctaHover: brand.colors.hoverRed,
  ctaPressed: brand.colors.pressedRed,
  gray1: brand.colors.gray,
  gray2: brand.colors.lightGray,
  gray3: brand.colors.silver,
  gray4: brand.colors.sonicSilver,
  gray5: brand.colors.drkGray,
  primary: brand.colors.darkBlue,
  info: brand.colors.lightBlue,
  warning: brand.colors.errorRed,
  success: brand.colors.green,
};

const breakpoints = ['600px', '900px', '1440px'];
const breakpointMap: Record<string, string> = {
  tablet: breakpoints[0]!,
  desktop: breakpoints[1]!,
  max: breakpoints[2]!,
};

const theme = {
  brand,
  breakpointMap,
  breakpoints,
  colors,
  fonts,
  spacing,
  spacingPx,
};

export type ThemeColorName = keyof ThemePalette;
export type ThemeBreakpointName = keyof typeof breakpointMap;
export type ThemeSpacingName = keyof typeof spacingPx;
export type Theme = typeof theme;

export default theme;
